import { FormControl, FormItem, FormLabel } from "@/src/components/ui/form";
import { Input } from "@/src/components/ui/input";
import { Slider } from "@/src/components/ui/slider";
import { useFormContext } from "react-hook-form";

export const Price = ({ priceMinDefault, priceMaxDefault }: { priceMinDefault: number; priceMaxDefault: number }) => {
  const { watch, setValue } = useFormContext();
  const priceMin = watch("priceMin");
  const priceMax = watch("priceMax");

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-3">Price per charter week</h3>
      <div className="flex flex-col gap-y-6 w-full">
        <div className="flex gap-x-4">
          <FormItem className="w-full">
            <FormLabel>Minimum</FormLabel>
            <FormControl>
              <Input
                value={priceMin}
                onChange={(event) => {
                  return setValue("priceMin", +event.target.value, { shouldDirty: true });
                }}
                onBlur={(e) => {
                  const p = +e.currentTarget?.value;
                  if (p < priceMinDefault) {
                    setValue("priceMin", priceMinDefault, { shouldDirty: true });
                  } else if (p >= priceMaxDefault) {
                    if (p > priceMax) {
                      setValue("priceMax", priceMaxDefault, { shouldDirty: true });
                      setValue("priceMin", priceMinDefault, { shouldDirty: true });
                    } else {
                      setValue("priceMin", priceMaxDefault, { shouldDirty: true });
                    }
                  } else {
                    if (p > priceMax) {
                      setValue("priceMax", p, { shouldDirty: true });
                      setValue("priceMin", p - 1, { shouldDirty: true });
                    }
                  }
                }}
              />
            </FormControl>
          </FormItem>
          <FormItem className="w-full">
            <FormLabel>Maximum</FormLabel>
            <FormControl>
              <Input
                max={priceMaxDefault}
                value={priceMax}
                onChange={(event) => {
                  return setValue("priceMax", +event.target.value, { shouldDirty: true });
                }}
                onBlur={(e) => {
                  const p = +e.currentTarget?.value;
                  if (p < priceMinDefault) {
                    setValue("priceMin", priceMinDefault, { shouldDirty: true });
                    setValue("priceMax", priceMinDefault, { shouldDirty: true });
                  } else if (p >= priceMaxDefault) {
                    if (p > priceMin) {
                      setValue("priceMax", priceMaxDefault, { shouldDirty: true });
                      setValue("priceMin", priceMinDefault, { shouldDirty: true });
                    } else {
                      setValue("priceMin", priceMaxDefault, { shouldDirty: true });
                    }
                  } else {
                    if (p < priceMin) {
                      setValue("priceMin", p - 1, { shouldDirty: true });
                      setValue("priceMax", p, { shouldDirty: true });
                    }
                  }
                }}
              />
            </FormControl>
          </FormItem>
        </div>
        <FormItem className="w-full">
          <FormControl>
            <Slider
              thumbs={[priceMin, priceMax]}
              value={[priceMin, priceMax]}
              min={priceMinDefault}
              max={priceMaxDefault}
              step={100}
              onValueChange={(value) => {
                setValue("priceMin", value[0], { shouldDirty: true });
                setValue("priceMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
      </div>
    </div>
  );
};
